module.exports = __webpack_public_path__ + "img/117ne.75266cd8.svg";